import {
  CheckVersionRequest,
  PatrickServiceClient,
  CheckVersionResponse,
  EnvironmentRequest,
  EnvironmentResponse,
} from '@policyfly/protobuf/patrick'

import { devtools } from '@/plugins/devtools/api'

import type { ApiVariableEndpoints, CreateEndpointParams } from '@/stores/api'

export interface EnvironmentApiEndpoints {
  /**
   * Retrieves information about the current environment.
   */
  details: () => Promise<EnvironmentResponse>
  /**
   * Checks the current version of the application.
   */
  version: () => Promise<CheckVersionResponse>
}

/**
 * Creates endpoints related to the current environment.
 */
export const createEnvironmentEndpoints = (params: CreateEndpointParams): ApiVariableEndpoints<EnvironmentApiEndpoints> => {
  const patrickServiceClient = new PatrickServiceClient(params.transportAnonymous)

  const details: EnvironmentApiEndpoints['details'] = async function () {
    const request = EnvironmentRequest.create()
    const { response } = await patrickServiceClient.environment(request)
    devtools.logGrpc({
      logLevel: 'debug',
      description: 'Environment Details',
      messages: [
        { type: EnvironmentRequest, key: 'request', message: request },
        { type: EnvironmentResponse, key: 'response', message: response },
      ],
    })
    return response
  }

  const version: EnvironmentApiEndpoints['version'] = async function () {
    const request = CheckVersionRequest.create()
    const { response } = await patrickServiceClient.checkVersion(request)
    devtools.logGrpc({
      logLevel: 'debug',
      description: 'Check Version',
      messages: [
        { type: CheckVersionRequest, key: 'request', message: request },
        { type: CheckVersionResponse, key: 'response', message: response },
      ],
    })

    return response
  }

  const endpoints: EnvironmentApiEndpoints = {
    details,
    version,
  }
  return {
    django: endpoints,
    grpc: endpoints,
  }
}
